export const ClienteEntity = {
    id: null,
    numeroDocumento: '',
    nombres: '',
    apellidos: '',
    estadoCivil: '',
    fechaIngreso: '',
    departamento: '',
    provincia: '',
    distrito: '',
    ubigeo: '',
    direccion: '',
    telefono: '',
    email: '',
    tipoDocumento: 'DNI',
    enabled: true
};